import { denormalize } from 'normalizr';

import * as schemas from 'schemas';

export const getCustomerCredit = state =>
  denormalize(state.customerCredit.id, schemas.customerCredit, state.entities);



// WEBPACK FOOTER //
// ./src/store/customerCredit/selectors.js